/* globals localStorage window */
import React, { useCallback, useEffect, useState } from 'react';
import AdminProfile from './AdminProfile';
import ThemeSettings from './ThemeSettings';
import ChangePassword from './ChangePassword';
import NotificationSettings from './NotificationSettings';
import GoogleCalendar from './GoogleCalendar';
import { getZ3PConfiguration } from '../brainApi';
import { storeZ3PConfiguration, userIsZippityEmployee } from '../helper';
// A container where all the settings should be placed
const Settings = () => {
  const [googleCalendarEmail, setGoogleCalendarEmail] = useState(null);
  const [googleCalendarIsAuthorized, setGoogleCalendarIsAuthorized] = useState(
    null,
  );

  const checkForZ3PUpdates = useCallback(async () => {
    const z3pConfiguration = await getZ3PConfiguration();

    // This logic is slightly redundant, but we were getting an issue
    // where calling getZ3PConfiguration was setting local storage
    // before we could access local storage, so the check in
    // storeZ3PConfiguration was always coming out to find that
    // there was no change.
    const shouldReload =
      googleCalendarEmail !== z3pConfiguration.google_calendar_email ||
      googleCalendarIsAuthorized !==
        z3pConfiguration.google_calendar_is_authorized;

    storeZ3PConfiguration(z3pConfiguration, shouldReload);

    setGoogleCalendarEmail(z3pConfiguration.google_calendar_email);
    setGoogleCalendarIsAuthorized(
      z3pConfiguration.google_calendar_is_authorized,
    );
  }, [googleCalendarEmail, googleCalendarIsAuthorized]);

  useEffect(() => {
    // Since we authorize Google in a popup, we need to check for
    // Z3P updates when the main window comes back into focus
    window.addEventListener('focus', checkForZ3PUpdates);
    const currentZ3PConfig = JSON.parse(
      localStorage.getItem('z3pConfiguration'),
    );
    setGoogleCalendarEmail(currentZ3PConfig.google_calendar_email);
    setGoogleCalendarIsAuthorized(
      currentZ3PConfig.google_calendar_is_authorized,
    );

    if (window.opener) {
      window.close();
    }

    return () => {
      window.removeEventListener('focus', checkForZ3PUpdates);
    };
  }, [checkForZ3PUpdates]);

  return (
    <>
      <AdminProfile />
      <ThemeSettings />
      <ChangePassword />
      <NotificationSettings />
      {userIsZippityEmployee && <GoogleCalendar />}
    </>
  );
};

export default Settings;
